import { collection, get, all, query, where, update } from "typesaurus"
import { LicenseType } from "../types"

export interface AccountLicense {
  id: string
  district?: string
  accountId?: string
  created: number
  lastModified: number
  startDate: number
  endDate: number
  licenceSet: string
  licenseType: LicenseType
  licenseCount: number
  licenseMax: number
  name: string
  navCategory: string
  navName: string
  licensedUsers: { [key: string]: boolean }
  deleted?: boolean
  isExpired?: boolean
}

const collection_ref = collection<AccountLicense>("accountLicenses")

export const getLicenseById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllLicenses = () => {
  return all(collection_ref)
}

export const getLicenseWhereId = (id: string) => {
  return query(collection_ref, [where("id", "==", id)])
}

export const updateLicenseById = (
  id: string,
  newVals: Partial<AccountLicense>
) => {
  return update(collection_ref, id, newVals)
}

export const getLicenseWhereAccountId = (accountId: string) => {
  return query(collection_ref, [where("accountId", "==", accountId)])
}

export const getLicenseWhereDistrictId = (district: string) => {
  return query(collection_ref, [where("district", "==", district)])
}

export const getFullProgramLegacyLicenses = async (
  user: any,
  programs: string[]
) => {
  const licenseType = user.role === "Student" ? "student" : "educator"
  const lr = collection<any>("licenseRegistry")
  const data = await query(lr, [
    where("program", "in", programs),
    where("type", "array-contains", licenseType),
    where("licenseable", "==", true),
  ])
  const results = []
  const futureDate = new Date()
  futureDate.setDate(futureDate.getDate() + 1)
  for (const license of data) {
    results.push({
      id: license.data.id,
      name: license.data.content,
      navName: license.data.content,
      licenseSet: license.data.id,
      licenseType,
      licensedUsers: {
        [user.id]: true
      },
      endDate: futureDate,
      isExpired: false
    })
  }
  return results
}
